import { Icon } from '@repo/foundations';
import { memo } from 'react';

export const SentimentIcon = memo(({ sentiment }: { sentiment: string }) => {
	if (sentiment === 'positive') {
		return <Icon name="thumbUp" size="md" color="icon/primary/default" />;
	} else if (sentiment === 'negative') {
		return <Icon name="thumbDown" size="md" color="icon/primary/default" />;
	}
	return null;
});
